import { render, staticRenderFns } from "./ObsoleteLink.vue?vue&type=template&id=283c5474"
import script from "./ObsoleteLink.vue?vue&type=script&lang=js"
export * from "./ObsoleteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports